"use client"

import { useState } from "react"
import type { ProjectResponse } from "@/utils/types"
import { ProjectService } from "@/apis/project/ProjectService"
import { Button } from "@/components/ui/button"
import { Slider } from "@/components/ui/slider"

interface ProgressUpdateDialogProps {
    project: ProjectResponse
    isOpen: boolean
    onClose: () => void
    onProgressUpdate: () => void
}

export function ProgressUpdateDialog({ project, isOpen, onClose, onProgressUpdate }: ProgressUpdateDialogProps) {
    const [progress, setProgress] = useState<number>(project.progress || 0)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleProgressChange = (value: number) => {
        setProgress(value)
    }

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true)
            await ProjectService.updateProgress(project.id, progress)
            alert("Progresul proiectului a fost actualizat cu succes!")
            onProgressUpdate()
            onClose()
        } catch (error) {
            console.error("Error updating project progress:", error)
            alert("A apărut o eroare la actualizarea progresului")
        } finally {
            setIsSubmitting(false)
        }
    }

    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="fixed inset-0 bg-black/50" onClick={onClose}></div>
            <div className="relative z-10 w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
                <div className="mb-4">
                    <h2 className="text-lg font-semibold">Actualizare progres pentru {project.name}</h2>
                </div>
                <div className="py-4 space-y-6">
                    <div className="space-y-2">
                        <div className="flex justify-between">
                            <span>Progres:</span>
                            <span className="font-medium">{progress}%</span>
                        </div>
                        <Slider min={0} max={100} step={5} value={progress} onChange={handleProgressChange} />
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button variant="outline" onClick={onClose}>
                        Anulează
                    </Button>
                    <Button onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? "Se actualizează..." : "Actualizează progresul"}
                    </Button>
                </div>
            </div>
        </div>
    )
}

